import P from "components/P";
import FlexChild from "layouts/flex/FlexChild";
import VerticalFlex from "layouts/flex/VerticalFlex";
import { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom/dist";
import style from "./PartnersStoreManagementDetail.module.css";
import Center from "layouts/wrapper/Center";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import Container from "layouts/container/Container";
import { requester } from "App";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import clsx from "classnames";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function PartnersStoreManagementDetail(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const [data, setData] = useState();
    const [kiosks, setKiosks] = useState([]);
    const [devices, setDevices] = useState([]);
    const [isMounted, setMounted] = useState(false);
    const [salesOverview, setSalesOverview] = useState();
    const { isMobile } = useContext(BrowserDetectContext);

    useEffect(() => {
        setMounted(true);
    }, [])
    useEffect(() => {
        if (isMounted) {
            let storeData = { id: data?.id }
            requester.getVendorStoreSalesOverview(storeData, (result) => {
                setSalesOverview(result.data);
            })
        }
    }, [isMounted])
    useEffect(() => {
        if (props.data) {

            setData(props.data);
        }
    }, [props])
    useEffect(() => {
        if (location.state) {
            setData(location.state.data);
        }
    }, [location])


    useEffect(() => {
        if (data) {
            console.log("data", data);
            // machines 배열을 순회하며 키오스크와 기기를 분류
            const kiosksTemp = data.machines.filter(machine => machine.machineType === "KIOSK");
            const devicesTemp = data.machines.filter(machine => machine.machineType !== "KIOSK");
            setKiosks(kiosksTemp);
            setDevices(devicesTemp);
            console.log(data);
        }

    }, [data])

    const handleManage = (data) => {
        // 관리 작업 처리, 예를 들어 다른 페이지로 이동하거나 모달을 열기 등
        navigate(`/partners/vending/management/detail/${data.id}`, { state: { data: data } })
    };

    return (
        <Container padding={10}>
            {
                data &&
                <VerticalFlex gap={10} alignItems={"flex-start"} justifyContent={"flex-start"}>
                    <FlexChild alignItems={"flex-start"} height={"initial"}>
                        <P size={20}>{data.storeName}</P>
                    </FlexChild>
                    <FlexChild >
                        <HorizontalFlex gap={10}>
                            <FlexChild>
                                <div className={clsx(style.card, { [style.mobile]: isMobile })}>
                                    <Center>
                                        <P>일일 매출액</P>
                                        <P color={"darkcyan"}>{salesOverview ? salesOverview.todayTotalPrice.toLocaleString() : 0} 원</P>
                                    </Center>
                                </div>
                            </FlexChild>
                            <FlexChild>
                                <div className={clsx(style.card, { [style.mobile]: isMobile })}>
                                    <Center>
                                        <P>금주 매출액</P>
                                        <P color={"darkcyan"}>{salesOverview ? salesOverview.thisWeekTotalPrice.toLocaleString() : 0}원</P>
                                    </Center>

                                </div>
                            </FlexChild>
                            <FlexChild>
                                <div className={clsx(style.card, { [style.mobile]: isMobile })}>
                                    <Center>
                                        <P>당월 매출액</P>
                                        <P color={"darkcyan"}>{salesOverview ? salesOverview.thisMonthTotalPrice.toLocaleString() : 0}원</P>
                                    </Center>

                                </div>
                            </FlexChild>
                        </HorizontalFlex>
                    </FlexChild>

                    <FlexChild>
                        <VerticalFlex gap={10}>
                            <FlexChild>
                                <HorizontalFlex gap={10}>
                                    {
                                        kiosks.length > 0
                                            ?
                                            kiosks.map((kiosk, index) => {
                                                return (
                                                    <FlexChild key={index}>
                                                        <div className={style.card}>
                                                            <VerticalFlex gap={15}>
                                                                <FlexChild>
                                                                    <div className={style.cardHeader}>
                                                                        <FontAwesomeIcon fontSize={20} icon={fas["faTabletAlt"]} color={kiosk.heartbeat ? 'green' : 'red'} />
                                                                        {/* <P size={20}>{kiosk.vendingName}</P> */}
                                                                        <P size={20}>{kiosk.vendingName}</P>
                                                                    </div>
                                                                </FlexChild>
                                                                {/* <FlexChild>
                                                                <img src={`data:image/png;base64,${kiosk.image}`} style={{ width: "70%" }} />
                                                            </FlexChild> */}
                                                            </VerticalFlex>
                                                        </div>
                                                    </FlexChild>
                                                );
                                            })
                                            :
                                            <FlexChild>
                                                <div className={style.card}>
                                                    <P size={15}>키오스크 데이터가 없습니다.</P>
                                                </div>
                                            </FlexChild>
                                    }
                                </HorizontalFlex>

                            </FlexChild>
                            <FlexChild>
                                <HorizontalFlex gap={15}>
                                    {
                                        devices.length > 0
                                            ?
                                            devices.map((device, index) => {
                                                return (
                                                    <FlexChild key={device.id}>
                                                        <div className={style.card} key={index}>
                                                            <VerticalFlex gap={10}>
                                                                <FlexChild>
                                                                    <div className={style.cardHeader}>
                                                                        <FontAwesomeIcon fontSize={20} icon={fas["faBuilding"]} color={device.heartbeat ? 'green' : 'red'} />
                                                                        <P size={20}>{device.vendingName}</P>
                                                                        {/* <P size={20}>{device.vendingName}</P> */}
                                                                    </div>
                                                                </FlexChild>
                                                                <FlexChild>
                                                                    <button onClick={() => handleManage(device)} className={style.manageButton}>관리</button>
                                                                </FlexChild>
                                                            </VerticalFlex>
                                                        </div>
                                                    </FlexChild>
                                                );
                                            })
                                            :
                                            <FlexChild>
                                                <div className={style.card}>
                                                    <P size={15}>머신 데이터가 없습니다.</P>
                                                </div>
                                            </FlexChild>
                                    }
                                </HorizontalFlex>
                            </FlexChild>
                        </VerticalFlex>
                    </FlexChild>
                </VerticalFlex>
            }
        </Container>
    );
}

export default PartnersStoreManagementDetail;